import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PhoneNumbersService {


  url = environment.serverAPI9 + "/api";


  constructor(private http: HttpClient) { }

  savePhoneNumbers(phoneNumber: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/phoneNumber`, phoneNumber)
  }

  getAllPhoneNumbers(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/phoneNumber?page=${Page}&size=${size}&sort=${sort}`);
  }
  getPhoneNumbersById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/phoneNumber/${id}`);
  }

  getUserById(): Observable<Object> {
    return this.http.get(`${this.url}/phoneNumber/user`);
  }

  PhoneNumbersSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/phoneNumber/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByPhoneNumberId(phoneNumberId: any): Observable<Object> {
    return this.http.delete(`${this.url}/phoneNumber/${phoneNumberId}`);
  }

  getAllDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/phoneNumber/dropdown`);
  }

}
